import { Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SessionService } from '../../services/session.service';
import { EmailStatus } from '../../models/user';
import { UserService } from '../../services/user/user.service';
import { FeatureFlagsService } from '../../services/featureFlags.service';

@Component({
  selector: 'app-email-confirmation-banner',
  templateUrl: './email-confirmation-banner.component.html',
})
export class EmailConfirmationBannerComponent implements OnInit, OnDestroy {
  show = false;
  userId: number | null = null;
  userEmail = '';
  emailStatus: EmailStatus = 'unverified';
  pending = false;
  gateOn = !!this.featureFlagsService.getByEnv('process', 'email_confirmation_gate');
  subs = new Subscription();

  constructor(
    private sessionService: SessionService,
    private userService: UserService,
    private featureFlagsService: FeatureFlagsService,
  ) {}

  ngOnInit() {
    this.refresh();
    this.subs.add(
      this.sessionService.primaryFacilityUpdatedTrigger.subscribe(() =>
        this.refresh(),
      ),
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  refresh() {
    this.subs.add(
      this.userService.getMe().subscribe(res => {
        const user = res.data;
        const isBuyer =
          !!user.roles?.includes('Buyer') &&
          !user.is_sales_representative &&
          !user.is_customer_representative;
        this.userId = user.id;
        this.userEmail = user.email;
        this.emailStatus = user.email_status;
        this.show = this.gateOn && isBuyer && user.email_status !== 'verified';
      }),
    );
  }

  resend() {
    this.pending = true;
    this.userService
      .verifyEmail({ id: this.userId, email: this.userEmail })
      .finally(() => (this.pending = false));
  }
}

@NgModule({
  declarations: [EmailConfirmationBannerComponent],
  imports: [CommonModule],
  exports: [EmailConfirmationBannerComponent],
})
export class EmailConfirmationBannerModule {}
